/** Pure motion helpers; every value is the prototype's own (P = plans/research-accelerator/mockups/screens-2026-10-23). */

/** P/Member_Hub.html:1810 */
export const RISE_EASING = 'cubic-bezier(.2,.7,.2,1)';
/** P/Member_Hub.html:1815 */
export const FADE_MS = 220;
/** P/grant-finder.html:1224 */
export const REVEAL_SLIDE_PX = 14;

/** P/Member_Hub.html:1813 */
export function RiseKeyframes(distancePx: number): Keyframe[] {
    return [
        { opacity: 0, transform: `translateY(${distancePx}px)` },
        { opacity: 1, transform: 'translateY(0)' },
    ];
}

/** P/Member_Hub.html:1814 */
export function RiseTiming(index: number): KeyframeAnimationOptions {
    return { duration: 280, delay: Math.min(index, 8) * 35, easing: RISE_EASING, fill: 'backwards' };
}

/** P/Member_Hub.html:1816 */
export function FadeKeyframes(): Keyframe[] {
    return [{ opacity: 0 }, { opacity: 1 }];
}

/** P/grant-finder.html:1224 */
export function RevealKeyframes(direction: number): Keyframe[] {
    const dx = Math.sign(direction) * REVEAL_SLIDE_PX;
    return [
        { opacity: 0, transform: `translateX(${dx}px)` },
        { opacity: 1, transform: 'none' },
    ];
}

/** P/grant-finder.html:1224 */
export function RevealTiming(): KeyframeAnimationOptions {
    return { duration: 280, easing: RISE_EASING };
}

/** First 8 cards: 8px rise, 40 + 35i ms. P/grant-finder.html:1229-1230 */
export function RevealCardTiming(index: number): KeyframeAnimationOptions {
    return { duration: 320, delay: 40 + index * 35, easing: RISE_EASING, fill: 'backwards' };
}

/** Slide direction from tab order (P/grant-finder.html:1233: rec = 0, search = 1). */
export function RevealDirection(oldIndex: number, newIndex: number): number {
    return Math.sign(newIndex - oldIndex);
}

/** P/Member_Hub.html:1809; checked at animate time, never cached. */
export function ReducedMotion(): boolean {
    return typeof globalThis.matchMedia === 'function' && globalThis.matchMedia('(prefers-reduced-motion: reduce)').matches;
}
